type Params = Record<
  string,
  string | number | boolean | (string | number | boolean)[] | null | undefined
>;

export const buildSearchParam = (params: Params): string => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // 배열 값 처리
      value.forEach((v) => searchParams.append(key, String(v)));
    } else if (value !== undefined && value !== null) {
      // 일반 값 처리
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
};
